export default __webpack_public_path__ + "media/images/celeste_background-c55b71d69533fa2e51d2916c81dd1179.png";